import { useAppSelector } from 'helpers/hooks';
import { getActiveRole } from 'selectors/admins';
import { getUserClientId } from 'selectors/user';
import { getIsSuper, getIsRecipient } from 'config/permissions';
import { getAccessToken } from 'services/storage';

/** Shared client+role auth scope for dashboard views; `isReady` gates rendering, `hasClient` gates client-scoped fetches. */
export const useAdminAuth = () => {
  const activeRole = useAppSelector(getActiveRole);
  const clientId = useAppSelector(getUserClientId);
  const accessToken = getAccessToken();

  return {
    // 0 for a super admin's "ALL" selection; request actions omit client_id for it.
    clientId,
    activeRole,
    accessToken,
    isSuper: getIsSuper(activeRole),
    // 0 (super's ALL) and null (unresolved) are not specific clients, so client-scoped fetches must not fire on them.
    hasClient: Boolean(accessToken && activeRole && clientId),
    // Recipient admins operate without a client; every other role is ready once a selection is made — a specific client or super's ALL (0), but not the unresolved null.
    isReady: Boolean(accessToken && activeRole && (getIsRecipient(activeRole) || clientId != null)),
  };
};
